import React from 'react';

import GppGoodIcon from '@mui/icons-material/GppGood';
import {Typography} from '@mui/material';
import {Box} from '@mui/system';
import {useTranslation} from 'react-i18next';

const PoweredByModak = () => {
  const {t} = useTranslation();
  return (
    <Box>
      <Box className="payment-link-valid-security-container">
        <Box className="payment-link-valid-security-icon">
          <GppGoodIcon className="payment-link-security-icon-header" />
        </Box>
        <Box className="payment-link-valid-security-text">
          <Box>
            <Typography className="text-block-powered-by">
              {t('payment_link.powered_by')}
            </Typography>
          </Box>
          <Box className="payment-link-valid-security-modak-icon">
            <img
              src="/assets/icons/modak.svg"
              alt="modak"
            />
          </Box>
        </Box>
      </Box>
      <Box>
        <Typography className="text-block-family-banking">
          {t('payment_link.family_banking')}
        </Typography>
      </Box>
    </Box>
  );
};

export default PoweredByModak;
